import { apiSlice } from "application/api/apiSlice";
import { API_PREFIX } from "data/constants";

export const clientApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMeClient: builder.query({
      query: () => ({
        url: API_PREFIX + "/client/",
        method: "GET",
      }),
      providesTags: ["Client"],
    }),
    getMyBookings: builder.query({
      query: () => ({
        url: API_PREFIX + "/client/bookings",
        method: "GET",
      }),
      providesTags: ["Bookings"],
      invalidatesTags: ["Bookings"],
    }),
    uploadClientAvatar: builder.mutation({
      query: (file) => ({
        url: API_PREFIX + "/client/upload/avatar",
        method: "POST",
        body: file,
      }),
    }),
    updateclient: builder.mutation({
      query: (client) => ({
        url: API_PREFIX + "/client/update",
        method: "PUT",
        body: client,
      }),
      invalidatesTags: ["Client"],
    }),
    updateClientSelf: builder.mutation({
      query: (client) => ({
        url: API_PREFIX + "/client/update/self",
        method: "PUT",
        body: client,
      }),
      invalidatesTags: ["Client"],
    }),
    changePassword: builder.mutation({
      query: ({ oldPassword, newPassword }) => ({
        url: API_PREFIX + "/client/changePassword",
        method: "POST",
        body: { oldPassword, newPassword },
      }),
      invalidatesTags: ["Client"],
    }),
  }),
});

export const {
  useGetMeClientQuery,
  useLazyGetMeClientQuery,
  useUploadClientAvatarMutation,
  useUpdateclientMutation,
  useGetMyBookingsQuery,
  useLazyGetMyBookingsQuery,
  useUpdateClientSelfMutation,
  useChangePasswordMutation,
} = clientApiSlice;
